import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PageLayout from '../components/PageLayout';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/');
    };

    return (
        <PageLayout
            breadcrumb={[
                { label: 'Home', to: '/' },
                { label: 'Privacy Policy' }
            ]}
            showBack={false}
            showClose={true}
            onClose={handleClose}
            icon={<PrivacyTipIcon fontSize="large" />}
            title="Privacy Policy"
            subTitle="Your privacy is important to us"
        >
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Typography variant="body1" paragraph>
                    Grind Analytics LLC (&quot;Grind Analytics&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website (the &quot;Site&quot;). By using the Site, you agree to the collection and use of your information in accordance with this Privacy Policy.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>1. Information Collection:</strong> We may collect personal information such as your name, email address, and other details you provide when you register or use our services. We also collect non-personal information through cookies and similar technologies.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>2. Use of Information:</strong> The information we collect is used to provide and improve our services, manage user accounts, and send you updates or marketing communications. We do not sell or rent your personal information to third parties.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>3. Disclosure of Information:</strong> We may share your information with our trusted service providers who assist us in operating our website or conducting our business. We may also disclose your information if required by law or to protect our rights.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>4. Data Security:</strong> We use commercially reasonable measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, so we cannot guarantee its absolute security.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>5. Cookies:</strong> Our Site uses cookies to enhance your experience. You can choose to disable cookies through your browser settings, but this may affect the functionality of the Site.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>6. Changes to This Privacy Policy:</strong> We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. Your continued use of the Site after the effective date of the revised Privacy Policy constitutes your acceptance of the changes.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>7. Contact Us:</strong> If you have any questions about this Privacy Policy, please contact us at privacy@grindanalytics.com.
                </Typography>
                <Box sx={{ mt: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                        Last updated: March 21, 2025
                    </Typography>
                </Box>
            </Container>
        </PageLayout>
    );
}
